"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moreServicesNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const extractProductInfoItem = (product, title, backgroundColor, link) => {
    if (!product) {
        return null;
    }
    const res = {
        name: product.name,
        alias: product.alias,
        titleSection: title,
        backgroundColor: backgroundColor,
        titleLink: link
    };
    const { fields } = product;
    if (fields) {
        res.labelCard = fields === null || fields === void 0 ? void 0 : fields.labelCard;
        res.imageCard = { imgSrc: fields === null || fields === void 0 ? void 0 : fields.imgSrc, imgSrcWebp: fields === null || fields === void 0 ? void 0 : fields.imgSrcWebp };
        res.description = fields === null || fields === void 0 ? void 0 : fields.description;
        res.nombreComercial = fields === null || fields === void 0 ? void 0 : fields.title;
        res.crossedPrice = fields === null || fields === void 0 ? void 0 : fields.crossedPrice;
        res.postPrice = fields === null || fields === void 0 ? void 0 : fields.postPrice;
        res.prePrice = fields === null || fields === void 0 ? void 0 : fields.prePrice;
        res.price = fields === null || fields === void 0 ? void 0 : fields.price;
        res.promoLabel = fields === null || fields === void 0 ? void 0 : fields.promoLabel;
        res.promoLabelTheme = fields === null || fields === void 0 ? void 0 : fields.promoLabelTheme;
        res.unityCrossedPrice = fields === null || fields === void 0 ? void 0 : fields.unityCrossedPrice;
        res.unityPrice = fields === null || fields === void 0 ? void 0 : fields.unityPrice;
        res.link = fields === null || fields === void 0 ? void 0 : fields.link;
        res.btn = fields === null || fields === void 0 ? void 0 : fields.btn;
        res.targetUrl = fields === null || fields === void 0 ? void 0 : fields.target;
    }
    return res;
};
const extractProductInfoMoreServices = (fields) => {
    const { cards, title, backgroundColor, titleLink } = fields;
    if (Array.isArray(cards)) {
        return cards.map((productItem) => extractProductInfoItem(productItem, title, backgroundColor, titleLink));
    }
    else {
        return extractProductInfoItem(cards, title, backgroundColor, titleLink);
    }
};
const normalizeOrionStructureItem = (product) => {
    var _a, _b;
    let res = null;
    if (product) {
        res = {};
        const imageCard = product === null || product === void 0 ? void 0 : product.imageCard;
        const textRecommended = product === null || product === void 0 ? void 0 : product.labelCard;
        const nombreComercial = product === null || product === void 0 ? void 0 : product.nombreComercial;
        const description = product === null || product === void 0 ? void 0 : product.description;
        const promoLabel = product === null || product === void 0 ? void 0 : product.promoLabel;
        const promoLabelTheme = product === null || product === void 0 ? void 0 : product.promoLabelTheme;
        const prePrice = product === null || product === void 0 ? void 0 : product.prePrice;
        const postPrice = product === null || product === void 0 ? void 0 : product.postPrice;
        const targetUrl = product.targetUrl;
        let textPrice = "";
        const crossedPrice = product === null || product === void 0 ? void 0 : product.crossedPrice;
        const button = Object.assign({}, (_a = product === null || product === void 0 ? void 0 : product.btn) === null || _a === void 0 ? void 0 : _a.fields);
        const buttonLink = Object.assign({}, (_b = product === null || product === void 0 ? void 0 : product.link) === null || _b === void 0 ? void 0 : _b.fields);
        if (!!button) {
            // eliminar cuando se cambié el dato en la contri
            button.type = "primary";
            button.height = "small";
            button.width = "default";
        }
        if (!!buttonLink) {
            // eliminar cuando se cambié el dato en la contri
            buttonLink.height = "small";
            buttonLink.width = "default";
        }
        if (product.titleSection) {
            res["Text-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-0"]), { text: product.titleSection || "", color: product.backgroundColor || "" });
        }
        if (product.titleSection && product.titleLink) {
            res["CustomLink-2"] = Object.assign(Object.assign({}, mocks_json_1.default["CustomLink-2"]), { href: product.titleLink, title: product.titleSection || "" });
        }
        if (imageCard && imageCard.imgSrc && imageCard.imgSrcWebp) {
            res["Image-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Image-1"]), { src: "https://prod.cms.col.movistar.es" + imageCard.imgSrc, srcWebp: "https://prod.cms.col.movistar.es" + imageCard.imgSrcWebp, alt: nombreComercial || "", hash: global.hash || '' });
        }
        let currency = "";
        let quote = "";
        if (product === null || product === void 0 ? void 0 : product.unityPrice) {
            const currencySplit = product.unityPrice.split("/");
            currency = currencySplit[0];
            quote = currencySplit[1] || "";
        }
        let price1 = { currency };
        let price2 = { price: product === null || product === void 0 ? void 0 : product.price, currency, quote };
        if (product.alias) {
            res.alias = product.alias || "";
        }
        if (!!crossedPrice) {
            if ((product === null || product === void 0 ? void 0 : product.price) !== crossedPrice) {
                price1.price = crossedPrice;
                price2 = Object.assign(Object.assign({}, price2), { price: product.price, color: "red_dark" });
            }
        }
        else {
            if (!(product === null || product === void 0 ? void 0 : product.price)) {
                price2 = {
                    price: null,
                    currency: product === null || product === void 0 ? void 0 : product.unityPrice,
                    quote: "",
                };
            }
            if (!(product === null || product === void 0 ? void 0 : product.unityPrice)) {
                price2 = {
                    price: null,
                    currency: "",
                    quote: "",
                };
                textPrice = product === null || product === void 0 ? void 0 : product.price;
            }
        }
        if (!!nombreComercial) {
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: nombreComercial });
        }
        if (!!description) {
            res["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: description });
        }
        if (!!prePrice) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: prePrice });
        }
        if (!!postPrice) {
            res["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), { text: postPrice });
        }
        if (!!textRecommended) {
            res["Label-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-0"]), { text: textRecommended });
        }
        if (!!promoLabel) {
            res["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-1"]), { label: promoLabel, theme: promoLabelTheme || mocks_json_1.default["Label-1"].theme });
        }
        if (price1 && price1.price) {
            res["Price-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-1"]), price1);
        }
        if (price2 && (price2.price || price2.currency)) {
            res["Price-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-2"]), price2);
        }
        if (textPrice) {
            res["Price-Text"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-Text"]), { text: textPrice });
        }
        if (button && button.href) {
            let finalhref = button.href;
            if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
                finalhref =
                    button.href.trim().length > 0
                        ? button.href.indexOf("?") !== -1
                            ? `${button.href}&utm_source=novum`
                            : `${button.href}?utm_source=novum`
                        : "";
            }
            res["Button-1"] = Object.assign(Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), button), { href: finalhref });
        }
        else if (button && button.idModal) {
            res["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), button);
        }
        if (buttonLink && buttonLink.href) {
            res["Button-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-3"]), buttonLink);
            res["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["CustomLink-1"]), { href: buttonLink.href, title: nombreComercial || "" });
            if (!!targetUrl) {
                res["CustomLink-1"].target = targetUrl;
                res["Button-3"].target = targetUrl;
            }
        }
    }
    return res;
};
const normalizeOrionStructure = (products) => {
    let productsObj = [];
    if (Array.isArray(products)) {
        products.forEach((product, i) => (productsObj.push(normalizeOrionStructureItem(product))));
    }
    return productsObj;
};
const cardsDetailToContentInfo = (cards) => {
    const result = [];
    const cardsToProcess = new Array(...cards);
    while (cardsToProcess.length) {
        const firstFour = cardsToProcess.splice(0, 4);
        result.push(firstFour.reduce((previous, currentCard) => {
            const title = currentCard['Text-0'].text;
            if (previous.hasOwnProperty(title)) {
                previous[title].items.push(currentCard);
                return previous;
            }
            previous[title] = {
                'Text-0': currentCard['Text-0'],
                'CustomLink-2': currentCard['CustomLink-2'],
                items: [
                    currentCard
                ]
            };
            return previous;
        }, {}));
    }
    return result;
};
const cardsDetailToContentInfoMobile = (cards) => {
    const result = cards.reduce((previous, currentCard) => {
        const title = currentCard['Text-0'].text;
        if (previous.hasOwnProperty(title)) {
            previous[title].items.push(currentCard);
            return previous;
        }
        previous[title] = {
            'Text-0': currentCard['Text-0'],
            'CustomLink-2': currentCard['CustomLink-2'],
            items: [
                currentCard
            ]
        };
        return previous;
    }, {});
    // Lo tranformo a un array por categoria
    const resultArray = Object.keys(result).map((key) => ({
        [key]: result[key],
    }));
    return resultArray;
};
/**
 * normalizador de la DISTRI DE MAS SERVICIOS
 * @param {object} fields
 * @returns
 */
const moreServicesNormalizer = (data) => {
    try {
        let res = {};
        if (Array.isArray(data)) {
            const allCards = [];
            data.forEach((element) => {
                const products = extractProductInfoMoreServices(element === null || element === void 0 ? void 0 : element.fields);
                allCards.push(products);
            });
            // Para tener todas las cards en un único arreglo
            let result = [];
            allCards.forEach((arreglo) => {
                result = result.concat(arreglo);
            });
            // Normalizamos la data de las cards
            const cards = normalizeOrionStructure(result);
            // Sacamos cada fila de cards
            res["Content"] = cardsDetailToContentInfo(cards);
            // Sacamos otra estructura para mobile
            res["ContentMobile"] = cardsDetailToContentInfoMobile(cards);
            res["Name"] = "MORE_SERVICES_BOX";
            return res;
        }
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.moreServicesNormalizer = moreServicesNormalizer;
exports.default = exports.moreServicesNormalizer;
//# sourceMappingURL=index.js.map